/******************************************************************************
 * Created Date: Thursday Febuary 24th 2022                                   *
 * Author: Jan A.                                                             *
 * -----                                                                      *
 * Last Modified: Thu Feb 24 2022                                             *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/utils/objects.js                                                *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

function isEmpty(object) {
  for (const property in object) {
    return false;
  }
  return true;
}

export { isEmpty };
